import React from 'react';

export default function IconSocialFacebook() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon-SocialFacebook">
        <path
          id="Vector"
          d="M10.1611 3.45312C9.33428 3.45312 9.09524 3.81821 9.09524 4.62344V5.95925H11.3006L11.0796 8.11735H9.0961V14.6667H6.44948V8.11735H4.6665V5.95925H6.44948V4.66012C6.44948 2.48326 7.33111 1.33341 9.79095 1.33341C10.3064 1.3322 10.8215 1.36269 11.3332 1.42468V3.45568L10.1611 3.45312Z"
          fill="#142138"
        />
      </g>
    </svg>
  );
}
